import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import V404 from '@/views/error/404'
import V401 from '@/views/error/401'
import Index from '@/views/index/layout/Index'
// import Projects from '@/views/index/projects/Projects'
// 调用Vue.use，把VueRouter安装为Vue的插件
Vue.use(VueRouter)
// 定义hash地址与对应组件之间的对应关系
let defaultUrl='/login'
console.log('localStorage== sessionStorage==',localStorage.getItem('token'),sessionStorage.getItem('token'))
if((sessionStorage.getItem('token')!=undefined&&sessionStorage.getItem('token')!=null)||(localStorage.getItem('token')!=undefined&&localStorage.getItem('token')!=null)){
    //sessionStorage.setItem('token',localStorage.getItem('token'))
    defaultUrl='/index'
}
//console.log('默认地址=',defaultUrl)
const routes = [
    {
        path: '/index',
        component: Index,
        /*redirect: '/projects',
        children: [
            {
                path: '/projects',
                name: 'projects',
                label: '项目管理',
                icon: 'xiangmu',
                url: 'views/index/projects/Projects',
                component: Projects
            }
        ]*/
    },{
        path: '/',
        redirect: defaultUrl
    },{
        path: '/login',
        component: Login
    },{
        path: "/404",
        component: V404,
        hidden: true
    },{
        path: '/article',
        component: () => import('@/views/app/Article'),
        hidden: true
    },{
        path: '/pdf',
        component: () => import('@/views/app/Pdf'),
        hidden: true
    }
]
export const commonroutes = [
    {
        path: '/401',
        component: V401,
        hidden: true
    },{
        path: "/404",
        component: V404,
        hidden: true
    },{
        path: '*',
        redirect: "/404"
    }
]
// 创建路由实例对象
const createRouter = () => new VueRouter({
    routes,
    // return期望滚动到哪个位置
    scrollBehavior (to, from, savedPosition) {
        if(savedPosition){
            return savedPosition
        }else{
            return { x: 0, y: to.meta.top || 0}
        }
    },
    // mode: 'history'
    // base: 'kswabk'
})
const router = createRouter()
const originPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {

    return originPush.call(this, location).catch(err => err)
}
// router设置全局前置守卫
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // to 将要访问路径
    // from 代表从哪个路径跳转而来
    // next 是一个函数，表示放行
    // next() 放行 next('/login') 强制跳转

    if (to.path === '/login'||to.path === '/article'||to.path === '/404'||to.path === '/pdf'){
        next()
    }else if(to.matched.length===0){// 如果未匹配到路由
        // console.log('未匹配到路由',to,router)
        from.path ? next({path:from.path}) : next('/404') // 如果上级也未匹配到路由规则跳转登录页面，如果能匹配到则转上级路由
    }else{
        //获取token
        const tokenStr = sessionStorage.getItem('token')
        if (tokenStr!=undefined&&tokenStr!='') {
            next()
        }else{
            next({
                path: '/login',
                query: {name: to.name,label:to.meta.title,redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由-xlz
            })
        }
    }

    /*if(to.matched.length===0){
        console.log('未匹配到路由',to)
        from.name ? next({name:from.name}) : next()
    }else{
        if (to.path === '/login'||to.path === '/article'||to.path === '/404'||to.path === '/project') return next()
        const tokenStr = localStorage.getItem('token')
        if (!tokenStr) return next('/login')
        next()
    }*/
})
router.onError((error)=>{
    const pattern = /Loading chunk (\d)+failed/g
    const isChunkLoadFailed = error.message.match(pattern)
    const targerPath = router.history.pending.fullPath
    if(isChunkLoadFailed){
        router.replace(targerPath)
    }
})
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}
// 向外共享路由的实例对象
export default router
